import React, { Component } from "react";
import { Link } from "react-router-dom";
import moment from "moment";

class NumberBox extends Component {
  state = {};

  formatDate = (dateString) => {
    return moment(dateString).format("DD MMM YYYY");
  };

  renderNumber = (number, format = "BBBBBBBBBB") => {
    let numArray = number.split("");
    let formatArray = format.split("");

    if (numArray.length !== 10 || format.length < 10) {
      return <span className="num">{numArray.join("")}</span>;
    }

    return (
      <React.Fragment>
        {formatArray.map((str, index) => {
          if (str === "-") {
            return (
              <span key={index} className="num">
                {str}
              </span>
            );
          } else if (str === "S") {
            return <span key={index}>&nbsp;</span>;
          } else if (numArray.length > 0) {
            let num = numArray.shift();
            return (
              <span
                key={index}
                className={`num ${str === "R" ? "red-text" : ""}`}
              >
                {num}
              </span>
            );
          }
        })}
      </React.Fragment>
    );
  };

  render() {
    let numberData = this.props.numberData || {};
    let price = numberData.price;
    let number = numberData.number;
    let sumOne = numberData.sumOne;
    let sumTwo = numberData.sumTwo;
    let format = numberData.format;
    let badgeName = numberData.badgeName || "";
    let discount = parseInt(numberData.discount) || 0;

    //calculating discounted price
    let discountedPrice = parseFloat((price - (price * discount) / 100).toFixed(2));

    return (
      <div className="col-12 col-md-6 col-lg-4 NumberBox">
        <div className="box position-relative">
          {discount !== 0 && (
            <div
              className="discount"
              style={{
                position: "absolute",
                left: "4px",
                top: "4px",
                height: "fit-content",
                width: "35x",
                borderRadius: "5px",
                backgroundColor: "red",
                color: "white",
                padding: "2px 10px",
                zIndex: "1",
              }}
            >
              <span>{discount}% OFF</span>
            </div>
          )}
          {badgeName && (
            <div className="ribbon ribbon-top-right">
              <span>{badgeName}</span>
            </div>
          )}
          <div className="top-bar"></div>
          <div className="num">{this.renderNumber(number, format)}</div>
          <p className="sum">
            {" "}
            Sum total: {sumOne || 40}={sumTwo || 4}
          </p>
          {numberData.isAvailableForPrebooking !== 0 && (
            <div className="prebooking-info">
              <p>{this.formatDate(numberData.prebookingAvailabilityDate)}</p>
            </div>
          )}
          <div className="icon">
            <div className="price">
              {discount > 0 ? (
                <>
                  <span
                    style={{
                      textDecoration: "line-through",
                      fontWeight: "medium",
                    }}
                  >
                    ₹ {price}/-
                  </span>
                  <h4
                    style={{
                      fontWeight: "bolder",
                      fontSize: "19px",
                      marginBottom: "20px",
                    }}
                  >
                    ₹ {discountedPrice}/-
                  </h4>
                </>
              ) : (
                <h4
                  style={{
                    fontWeight: "bolder",
                    fontSize: "19px",
                    marginBottom: "20px",
                  }}
                >
                  ₹ {price}/-
                </h4>
              )}
            </div>
            <Link to={`/cart?addtoCart=true&numberId=${numberData.id}`}>
              <span className="shop-cart-icon" style={{ cursor: "pointer" }}>
                <i className="fa-sharp fa-solid fa-cart-shopping"></i>
                {numberData.isAvailableForPrebooking !== 0 ? (
                  <p className="icon-action">Book Now</p>
                ) : (
                  <p className="icon-action">Buy Now</p>
                )}
              </span>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default NumberBox;
